export default __webpack_public_path__ + "static/media/111.616ea76e.png";